<template>
  <div>
    <a-list
      itemLayout="horizontal"
      :dataSource="securityList"
    >
      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
        <a-list-item-meta>
          <a slot="title">{{ item.title }}</a>
          <span slot="description">
            <span class="security-list-description">{{ item.description }}</span>
            <span v-if="item.value"> : </span>
            <span class="security-list-value">{{ item.value }}</span>
          </span>
        </a-list-item-meta>
        <template v-if="item.actions">
          <a slot="actions" @click="item.actions.callback">{{ item.actions.title }}</a>
        </template>

      </a-list-item>
    </a-list>
    <update-password
      ref="updatePassword"
    />
  </div>
</template>

<script>
import UpdatePassword from './UpdatePassword'

export default {
  name: 'SecuritySettings',
  components: {
    UpdatePassword
  },
  computed: {
    securityList () {
      return [
        {
          title: this.$t('views.account.security.passwordTitle'),
          description: this.$t('views.account.security.passwordDesc'),
          value: this.$t('views.account.security.strengthStrong'),
          actions: {
            title: this.$t('views.account.security.edit'),
            callback: () => { this.$refs.updatePassword.handleUpdatePwd() }
          }
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
